import axios from 'axios'
import tollsMixin from '@/mixins/tollsMixin';

var form = {
  user_id: 0,
  items: [],
  discount: null,
  subtotal: 0,
  total: 0.00,
  coupon: null,
  tripDetails: {},
  hash: '',
  payment_method: 'bank_slip',
  installments: null,
  cpf: '',
  email: '',
  quote_id: null,
  order_id: null,
  source: '',
  garage: null,
}

function calculateVehicleUsageTotals(vehicleType, trip, usage) {
  var total = 0;
  if(usage) {
    Object.entries(trip.useVehicle).forEach(entry => {
      const [key, value] = entry;
      total += parseFloat(usage[value.selectedIndex][vehicleType])
    });
  }
  return total;
}

export default {
  namespaced: true,

  state: {
    cartData: form,
    response: null
  },

  getters: {
    response: state => state.response
  },

  mutations: {
    setClearCart (state, form) {
      state.cartData = {
        user_id: 0,
        items: [],
        discount: null,
        subtotal: 0,
        total: 0.00,
        coupon: null,
        tripDetails: {},
        hash: '',
        payment_method: 'bank_slip',
        installments: null,
        cpf: '',
        quote_id: null,
        email: '',
        order_id: null,
        source: '',
      }
      state.response = null
    },
    setPaymentMethod (state, paymentMethod) {
      state.cartData.payment_method = paymentMethod
    },
    setCoupon (state, data) {
      state.cartData.subtotal = state.cartData.total
      state.cartData.total = data.discounted_total
      state.cartData.discount = data.discount
      state.cartData.coupon = data.coupon
    },
    removeCoupon (state, coupon) {
      state.cartData.total = state.cartData.total + state.cartData.discount
      state.cartData.subtotal = state.cartData.total
      state.cartData.discount = 0
      state.cartData.coupon = null
    },
    setCartProp (state, data) {
      state.cartData[data.prop] = data.value
    },
    setCartItem (state, data) {
      if (state.cartData.items.length === 0 || Object.keys(state.cartData.items).length === 0) {
        state.cartData.items = []
      }
      state.cartData.platform = 'whitelabel';
      state.cartData.garage = data.metas.garage;
      state.cartData.items.push(data)
    },
    removeItem (state, data) {
      state.cartData.items.splice(data, 1)
    },
    defineCartSource (state, value) {
      state.cartData.source = value
    },
    setQuoteID (state, value) {
      state.cartData.quote_id = value
      state.cartData.items.forEach((el, index) => {
        el.quote_id = value
      })
    },
    setGarage (state, value) {
      state.cartData.garage = value
    },
    setDiscount (state, value) {
      state.cartData.discount = parseFloat(value)
    },
    setAddition (state, value) {
      state.cartData.addition = parseFloat(value)
    },
    updateVehiclePrice(state, { vehicleId, toll }) {
      var tollPrice = toll.totalPrice ? toll.totalPrice : 0;
   
      state.cartData.items = state.cartData.items.map(item => {
        if (item.selectedVehicle.id === vehicleId && !item.tollApplied) {
            const newTotal = parseFloat(item.selectedVehicle.total) + parseFloat(tollPrice);
    
            return {
                ...item,
                tollPrice: tollPrice,
                tollApplied: true,
                total: newTotal,
                selectedVehicle: {
                    ...item.selectedVehicle,
                    priceWithoutTolls: item.selectedVehicle.total ? item.selectedVehicle.total : item.selectedVehicle.priceCents,
                    total: newTotal,
                    tolls: toll,
                }
            };
        }
        return item;
      });
    },
    calculateCartTotal (state, details) {
      let subtotal = 0;
      let extraCost = 0;
      let discount = 0;
      let tollCost = 0;

      state.cartData.items.forEach((el, index) => {
        // if(el.driverExpenses && el.driverExpenses.enable && !el.selectedVehicle.usingTwoTrips){
        //   extraCost += el.driverExpenses.driverExpensesValue;
        // }

        // if(el.tripDetails && el.tripDetails.driverExpenses && !el.selectedVehicle.usingTwoTrips){
        //   extraCost += el.tripDetails.driverExpenses.driverExpensesValue;
        // }

        let trip = el.tripDetails;
        let vehicle = el.selectedVehicle;

        if (el.type === 'customtrip') {
          // extraCost += calculateVehicleUsageTotals( vehicle.type, el.tripDetails, details.data.companyDetails.vehicleUsageQuotes ) + trip.driverExpenses.driverExpensesValue;
          subtotal += el.selectedVehicle.total ? parseFloat(el.selectedVehicle.total) : parseFloat(el.selectedVehicle.priceCents);
        } else {

          if(!el.selectedVehicle.usingTwoTrips) {
            subtotal += el.selectedVehicle.total ? parseFloat(el.selectedVehicle.total) : parseFloat(el.selectedVehicle.priceCents);
          }else{
            subtotal += el.selectedVehicle.total ? parseFloat(el.selectedVehicle.total) : parseFloat(el.selectedVehicle.priceCents);
          }
        }
      })

      extraCost += 0;
      subtotal = parseFloat(subtotal)
      extraCost = extraCost && !isNaN(extraCost) ? parseFloat(extraCost) : 0
      discount = 0

      extraCost = isNaN(extraCost) || !extraCost ? 0 : extraCost;
      discount = 0;
  
      state.cartData.subtotal = subtotal
      state.cartData.total = subtotal - discount + extraCost

    }
  },

  actions: {
    clearCart ({ commit }) {
      commit('setClearCart', {
        cartData: form,
        response: null
      })
    },
    async calculateTolls({ commit, rootState }, cart) {
      var total = 0;
      const { buildTollsData } = tollsMixin.methods;

      const promises = cart.data.map(async (item) => {
        const hasSelectedVehicleTolls = item.selectedVehicle && item.selectedVehicle.tolls && Object.keys(item.selectedVehicle.tolls).length > 0;

        // Skip both toll calculation and meta update if item already has tolls data
        if (hasSelectedVehicleTolls) {
          return;
        }

        const tollsData = buildTollsData(cart.rootState, item);

        try {
         
          if(!item.tollApplied) {
            const response = await axios.post(
              `${process.env.API_URL}tolls/calculate`,
              tollsData
            );
            commit('cart/updateVehiclePrice', { vehicleId: item.selectedVehicle.id, toll: response.data }, { root: true });
          }
          
          // Only update meta if we calculated tolls
          var searchID = cart.rootState.searchData.id;
          var vehicleID = item.selectedVehicle.id;
          var metaKey = "useToll";
          var value = true;

          if(searchID) {
            const tollMetaUpdate = await axios.post(
              `${process.env.API_URL}search/update-meta`,
              {
                search_id: searchID,
                vehicle_id: vehicleID,
                key: metaKey,
                value: value
              }
            );
          }
        } catch (error) {
          console.error('Erro:', error.response || error);
        }

        await new Promise((resolve) => setTimeout(resolve, 500));
      });
      
      commit('cart/calculateCartTotal', { data: cart }, { root: true });
      await Promise.all(promises);
    },
    createOrder ({ commit }, data) {
      commit('setErrors', {}, { root: true })
      return axios
        .post(process.env.API_URL + 'order/create', data)
        .then(response => {
          return response
        })
        .catch(response => {

        })
    }
  }
}
